import React, { useState } from 'react';
import API_URL from '../config/api';

export function projectImageUrl(project) {
  const image = project.imagen || project.imagenes?.[0];
  if (!image) return '';
  if (/^https?:\/\//.test(image) || image.startsWith('/')) return image;
  return `${API_URL.replace(/\/$/, '')}/${image}`;
}

export function thumbnailUrl(url) {
  // Transform only unsigned original Cloudinary URLs, preserving other providers.
  return url.replace(/^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(v\d+\/)/, '$1f_auto,q_auto,w_720,c_limit/$2');
}

export default function ProjectImage({ project, eager }) {
  const original = projectImageUrl(project);
  const [fallback, setFallback] = useState(false);
  const [failed, setFailed] = useState(false);
  const thumbnail = thumbnailUrl(original);

  if (!original || failed) {
    return <div className="d-flex align-items-center justify-content-center bg-light text-muted" style={{ height: 200 }}>Imagen no disponible</div>;
  }

  return <img
    className="card-img-top"
    src={fallback ? original : thumbnail}
    alt={project.nombre}
    loading={eager ? 'eager' : 'lazy'}
    decoding="async"
    width="720"
    height="200"
    style={{ height: 200, width: '100%', objectFit: 'cover' }}
    onError={() => {
      if (!fallback && thumbnail !== original) setFallback(true);
      else setFailed(true);
    }}
  />;
}
